/**
 * Sparkline minimaliste pour visualiser une série (visites 7j).
 * Pas de dépendance externe — SVG pur.
 */
export function Sparkline({ data = [], accent = '#0A0E1A', width = 96, height = 26, testid }) {
  const values = Array.isArray(data) ? data.map((d) => Number(d.count || 0)) : [];
  if (!values.length) return null;
  const max = Math.max(1, ...values);
  const stepX = values.length > 1 ? width / (values.length - 1) : width;
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - (v / max) * (height - 4) - 2;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  const areaPoints = `${points} ${(width).toFixed(1)},${height} 0,${height}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className="overflow-visible"
      aria-hidden
      data-testid={testid}
    >
      <polygon fill={`${accent}22`} points={areaPoints} />
      <polyline fill="none" stroke={accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" points={points} />
      {values.map((v, i) => {
        const x = i * stepX;
        const y = height - (v / max) * (height - 4) - 2;
        return <circle key={i} cx={x.toFixed(1)} cy={y.toFixed(1)} r={v > 0 ? 1.6 : 1} fill={accent} />;
      })}
    </svg>
  );
}
